/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { AuthTokenResponse as ModelsAuthenticationAuthTokenResponse } from '../../models/Models/Authentication/auth-token-response';

export interface V4TokenGet$Plain$Params {
  client_id?: string;
  client_secret?: string;
  refresh_token?: string;
}

export function v4TokenGet$Plain(http: HttpClient, rootUrl: string, params?: V4TokenGet$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<ModelsAuthenticationAuthTokenResponse>> {
  const rb = new RequestBuilder(rootUrl, v4TokenGet$Plain.PATH, 'get');
  if (params) {
    rb.header('client_id', params.client_id, {});
    rb.header('client_secret', params.client_secret, {});
    rb.header('refresh_token', params.refresh_token, {});
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ModelsAuthenticationAuthTokenResponse>;
    })
  );
}

v4TokenGet$Plain.PATH = '/v4/token';
